import { Steps } from "pages/Home/ui/HowItWorks/ui/Steps";
import { FormattedMessage } from "react-intl";
import { Typography } from "@/shared/ui/Typography";
import { BLACK_COLOR } from "@/styles/colorsJS";

export const HowItWorks = () => {
  return (
    <section className="text-brand-text-secondary mt-[var(--landing-section-gap)] px-4">
      <div className="container">
        <Typography as="h2" type="h1" align="center" color={BLACK_COLOR}>
          <FormattedMessage defaultMessage="Как работает FactorPlus" />
        </Typography>
        <Steps />
      </div>
    </section>
  );
};
